import { Injectable, ErrorHandler } from "@angular/core";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor() {
    }

    handleError(error: any): void {
    }
}


// WEBPACK FOOTER //
// /home/node/src/app/_services/error-handler.service.ts